<template>
  <div style="min-width: 150px">
    <div v-if="editable" class="starContainer">
      <div v-for="button in buttons" :key="button" @mouseover="mouseOverGap($event)" @mouseout="mouseOutGap(selectedRating)">
          <i
            class="button1 fas fa-dumbbell ml-2"
            @click="clickHandler(button)"
            style="cursor: pointer;"
          ></i>
      </div>
    </div>
    <div v-else-if="rating >= 0" class="starContainer">
      <div v-for="button in buttons" :key="button">
        <div>
          <i
            class="button1 fas fa-dumbbell ml-2"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    rating: {
      default: 0,
      type: Number,
    },
    editable: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      buttons: [1, 2, 3, 4, 5],
      selected: false,
      selectedRating: null,
      counter: 0,
    };
  },
  mounted() {
    this.setRating();
  },
  // watch: {
  //   rating (){
  //     this.setRating();
  //   },
  // },
  methods: {
    clickHandler(rating) {
      let myElements = this.$el.querySelectorAll(".button1");
      for (let i = 0; i < 5; i++) {
        if (i < rating) {
          myElements[i].style.color = "#00C4FC";
        } else myElements[i].style.color = "#CCF3FE";
      }
      this.selected = true;
      this.selectedRating = rating;
      this.$emit('saveRating', rating);
    },
    setRating() {
      this.selectedRating = this.rating;
      let myElements = this.$el.querySelectorAll('.button1');
      for (let i = 0; i < this.selectedRating; i++) {
        myElements[i].style.color = "#00C4FC";
      }
    },
    mouseOverGap(event) {
      let stars = [...this.$el.querySelectorAll('.button1')];
      let x = event.clientX;

      let closestStar = getClosestStar(stars, x);
      closestStar = stars.indexOf(closestStar);


      for(const [index, star] of stars.entries()){
        if(index <= closestStar){
          star.style.color = "#00C4FC"
        } else {
          star.style.color = "#CCF3FE";
        }
      }

      function getClosestStar(stars, x){
        return stars.reduce((closest, child) => {
          const box = child.getBoundingClientRect();
          const offset = x - box.left - box.width /2 ;
          if(Math.abs(offset) < closest.offset){
            return {offset: offset, element: child}
          } else {
            return closest;
          }
        }, {offset: Number.POSITIVE_INFINITY}).element
      }
    },
    mouseOutGap(rating) {
      let stars = [...this.$el.querySelectorAll('.button1')];

      for(const [index, star] of stars.entries()){
        if(index < rating){
          star.style.color = "#00C4FC"
        } else {
          star.style.color = "#CCF3FE";
        }
      }
    }
  },
};
</script>

<style scoped>

.starContainer {
  display: flex; 
  align-items: center;
}

</style>
